import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

interface BasketItem {
  product_id: number;
  quantity: number;
  product: {
    id: number;
    name: string;
    price: number;
    formatted_price: string;
  };
}

interface BasketState {
  items: BasketItem[];
  isOpen: boolean;
  total: {
    raw: number | null;
    templated: string | null;
  };
  savings: {
    raw: number | null;
    templated: string | null;
  };
}

const initialState: BasketState = {
  items: [],
  isOpen: false,
  total: { raw: null, templated: null },
  savings: { raw: null, templated: null },
};

export const basketSlice = createSlice({
  name: "basket",
  initialState,
  reducers: {
    setOpen: (state, action: PayloadAction<boolean>) => {
      state.isOpen = action.payload;
    },
    
    setItems: (state, action: PayloadAction<BasketItem[]>) => {
      state.items = action.payload;
    },
    
    setTotal: (state, action: PayloadAction<{ raw: number; templated: string }>) => {
      state.total = action.payload;
    },
    
    setSavings: (state, action: PayloadAction<{ raw: number; templated: string }>) => {
      state.savings = action.payload;
    },
    
    clearBasket: (state) => {
      state.items = [];
    },
  },
});

export const {
  setOpen,
  setItems,
  setTotal,
  setSavings,
  clearBasket,
} = basketSlice.actions;

export default basketSlice.reducer;
